/* eslint-disable */

import React from "react";
import { Route, Redirect } from "react-router-dom";
import { Component } from "react";
import { connect } from "react-redux";
import NotFound from "../components/NotFound";
class AuthRouteGaurdComponent extends Component {
  render() {
    return (
      <PrivateRoute
        component={this.props.component}
        isAuthenticated={this.props.loginFlag}
        loginUserData={this.props.loginUserData}
        {...this.props}
      />
    );
  }
}

function PrivateRoute({
  component: Component,
  isAuthenticated,
  loginUserData,
  allowedRoles,
  ...rest
}) {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthenticated !== true) {
          return <Redirect to={"/login"} />;
        }

        if (
          allowedRoles &&
          !allowedRoles.includes(loginUserData && loginUserData.role)
        ) {
          return <NotFound />;
        }

        return <Component {...props} />;
      }}
    />
  );
}

const mapStateToProps = (state) => ({
  loginFlag: state.auth.loginFlag,
  loginUserData: state.auth.loginUserData,
});

const mapDispatchToProps = (dispatch) => {
  return {};
};

export const AuthRouteGaurd = connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthRouteGaurdComponent);
